import React from 'react';
import classnames from 'classnames/bind';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';
import { SideDrawer as ExternalSideDrawer, useIsMobile } from 'taboola-ultimate-ui';
import { useChatAgentContext } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentContext';
import { useMultiLayerDrawerEnabled } from '../../modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import styles from './sideDrawer.module.scss';

const classNameBuilder = classnames.bind(styles);

export const DRAWER_MODE = {
    SMALL: 'small-drawer',
    MEDIUM: 'medium-drawer',
    LARGE: 'large-drawer',
};

export const ANCHOR_DIRECTIONS = {
    RIGHT: 'right',
    LEFT: 'left',
};

export const SideDrawer = ({ drawerMode = DRAWER_MODE.SMALL, openDrawer, forceSideDrawer, ...restProps }) => {
    const isMobile = useIsMobile();
    const { chatAgentWidth } = useChatAgentContext();
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    //TODO: remove this unnecessary component DEV-167693;
    if (isMultiLayerDrawerEnabled && !forceSideDrawer) {
        if (isFunction(restProps.children)) {
            return close => restProps.children(close);
        }
        return <>{restProps.children}</>;
    }

    return (
        <ExternalSideDrawer
            anchorDirection={ANCHOR_DIRECTIONS.RIGHT}
            drawerClassName={classNameBuilder(drawerMode)}
            containerClassName={styles['container']}
            openDrawer={openDrawer}
            fitToScreen={isMobile}
            style={{ [ANCHOR_DIRECTIONS.RIGHT]: chatAgentWidth }}
            {...restProps}
        />
    );
};

SideDrawer.propTypes = {
    drawerMode: PropTypes.string,
    ...ExternalSideDrawer.propTypes,
};
